import { InvoiceStatus } from '@link/agent/services/const';

export default {
  common: {
    search: 'Search',
    keyword: 'Keyword',
    cancelAll: 'Bulk Cancellation',
    complete: 'Completed'
  },
  layouts: {
    sidebar: {
      notifications: 'Notifications',
      contractsList: 'Contract Management',
      agents: 'travel agency management',
      booking: 'Booking',
      settings: 'Settings',
      changePassword: 'Change Password',
      finance: 'Payment Management',
      bulkOrder: 'Bulk Booking',
      activityList: 'Product List'
    }
  },
  views: {
    activityList: {
      pageTitle: 'Product List',
      searchTitle: 'Product Search',
      activityId: 'Product ID',
      activityUrl: 'Product URL',
      title: 'Product Name',
      supplier: 'Supplier',
      supplierId: 'Supplier ID',
      supplierName: 'Supplier Name',
      category: 'Category',
      country: 'Country/Region',
      confirmationType: 'Inventory Type',
      inSalePeriod: 'Within Sales Period',
      unspecified: 'Not specified',
      salePeriod: 'Sales Period',
      netPrice: 'Wholesale Price',
      grossPrice: 'Selling Price (GROSS)',
      unlimited: 'Unlimited',
      downloadCsv: 'Download CSV',
      snapshotHint:
        'Data shown is as of the previous day (updated nightly). Last updated: {{time}}'
    },
    bulkBookingDetail: {
      history: 'Operation Details',
      action: 'Operation',
      operator: 'Operator',
      date: 'Date',
      message: 'message',
      notifyPayment: 'Remittance Notification',
      paymentDate: 'Remittance Date',
      paymentConfirmed: 'Remittance Confirmed',
      infoSentToSupplier: 'The information has been sent to the tour operator.'
    },
    bulkBookingForm: {
      operator: 'Operator',
      paymentDate: 'Scheduled Remittance Date',
      message: 'message',
      agentReservationNo: 'Travel agency reservation number (remarks)',
      agentReservationNote: 'Special notes for travel agency bookings'
    },
    addPrepayment: {
      agentId: 'Travel agency ID',
      agentName: 'Travel agency name',
      address: 'Company Address',
      date: 'Payment Due Date',
      currency: 'Currency',
      amount: 'Payment Amount',
      note: 'Send advance invoice to LINKTIVITY sales representative by email',
      submit: 'Prepayment Invoice Creation',
      reset: 'Reset'
    },
    financeHistory: {
      title: 'Payment History',
      dataAggregation: 'Data Aggregation',
      aggregationUnit: 'Unit of aggregation',
      targetPeriod: 'Applicable Period',
      monthly: 'Monthly',
      weekly: 'Biweekly',
      confirmed: 'Confirmed',
      canceledRefund: 'Cancellation Refund',
      differenceAdjusted: 'Adjustment Completed',
      totalAmount: 'Total Amount',
      cancellationFee: '(Includes cancellation fee)',
      totalPaymentAmount: 'Total Payment Amount',
      price: '({{currency}})',
      salesPrice: 'Selling price',
      wholesalePrice: 'Wholesale Price',
      commission: 'Commission',
      transactionSearch: 'Transaction Search',
      applicationDate: 'Application Date',
      participationDate: 'Participation Date',
      transactionStatus: 'Transaction Status',
      keyword: 'Keyword',
      activity: 'Product',
      plan: 'Plan',
      supplier: 'Tour operator',
      reservationNumber: 'Booking Number',
      currency: 'Currency'
    },
    financeTransactions: {
      title: 'Settlement Statement',
      transactionStatus: 'Settlement Status',
      difference: 'Adjustment',
      dueDate: 'Invoice Issue Date',
      invoiceNumber: 'Invoice ID',
      date: 'Billing Period',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: 'Currency',
      amount: 'Total Payment Amount',
      adjustedAmount: 'Adjustment Amount',
      finalAmount: 'Final Total Amount',
      adjust: 'Adjustment',
      showjust: 'Display',
      change: 'Paid',
      invoice: 'Billing Details',
      jaInvoice: 'Payment Notice (Japanese)',
      jaInvoiceDetails: 'Statement (Japanese)',
      enInvoice: 'Payment Notice (English)',
      enInvoiceDetails: 'Statement (English)',
      attachment: 'Attachment',
      changeTitle: 'Has payment been completed?',
      changeMessage: 'Change transaction status to “Paid”'
    },
    financeAccount: {
      title: 'Balance Management',
      listTitle: 'Recharge History',
      accountBalance: 'Account Balance',
      accountBuffer: 'Account Buffer',
      deposit: 'Charge',
      generatePrepaidInvoice: 'Prepayment Invoice Creation',
      billingCycle: 'Settlement Cycle',
      paymentMethod: 'Payment Method',
      currency: 'Currency',
      contractNote: 'The above settings are based on your contract.',
      contactSupport:
        'If any changes are required, please contact your LINKTIVITY representative.',
      date: 'Date & Time',
      amount: 'Amount',
      prepaidInvoice: 'Prepayment Invoice',
      transactionStatus: 'Status',
      remark: 'Remarks',
      accountBalanceAmount: 'Balance Before Top-up',
      accountBalanceAfterAmount: 'Balance After Top-up',
      accountBufferAmount: 'Reserve Balance (Account Buffer)',
      verificationCode: 'Confirmation Code',
      enterDepositAmount: 'Please enter recharge amount',
      depositAmount: 'Recharge Amount',
      proceedToPayment: 'Proceed to Payment',
      chargeCompleted: 'Remittance Completed',
      cancel: 'Cancellation',
      confirmChargeCompleted:
        'Notify LINKTIVITY that the remittance has been completed.',
      changeStatusToCharged:
        'The status will be changed to "Remittance Completed."',
      change: 'Operation',
      confirmCancel: 'Are you sure you want to cancel?',
      changeStatusToCancelled: 'Change the status to "Cancelled".',
      insufficientBalanceNotification: 'Set up low balance notification',
      notificationDialogTitle: 'Low Balance Notification Settings',
      notificationDialogSubtitle:
        'You will be notified by email when the balance falls below the specified amount.',
      notificationReceiveLabel: 'Receive notifications',
      notificationEnabled: 'Receive',
      notificationDisabled: 'Do not receive',
      notificationThresholdLabel: 'Balance Alert Threshold',
      notificationSave: 'Save settings'
    },
    dashboard: {
      title: 'Dashboard'
    },
    searchActivities: {
      title: 'New Booking',
      filter: {
        lang: 'Display Language',
        otaId: 'travel agency',
        supplierId: 'Tour operator',
        categories: 'Category',
        country: 'Departure Location',
        activityTitle: 'Product Name'
      },
      plan: 'Plan',
      openBookingForm: 'Open Booking Form',
      viewDetail: 'View Details',
      total: 'Search Results · {{total}}',
      location: '{{country}}',
      city: '・{{city}}',
      supplier: '{{name}} ({{id}})'
    },
    activityDetail: {
      plan: 'Select Plan',
      plans: {
        stockAndPrice: 'Inventory & Price',
        calendar: 'Inventory Calendar',
        priceCalendar: 'Price Calendar',
        quantity: 'Inventory Quantity',
        currentPrice: 'On-site Price',
        noDateSelected: 'Please select a date',
        unit: 'unit',
        displayPrice: 'Selling price',
        netPrice: 'Wholesale Price',
        otherDate: 'Different Applicable Date',
        priceTable: 'Price List',
        priceGroup: 'Price Group',
        applicablePeriod: 'Applicable Period',
        cannotBeBookIndependently: 'Cannot be purchased individually',
        commission: 'Commission'
      }
    },
    bookingForm: {
      title: 'Booking Form',
      steps: {
        step1: 'Basic Information',
        step2: 'Required Booking Information',
        step3: 'Booking Application'
      },
      prev: 'Previous Step',
      next: 'Next Step',
      form: {
        plans: 'Plan',
        targetDate: 'Participation Date',
        time: 'Start Time',
        amount: 'Number of People',
        amountDesc: 'Booking Quantity Limit: {{capacity}}',
        amountDescBulk:
          'Booking Quantity Limit: {{capacity}}; Up to 999 tickets can be booked per unit at a time.',
        accountBalance: 'Account Balance',
        availableAmount: 'Available Amount',
        checkPrice: 'Check Availability & Price',
        checkList: 'Participation Restrictions',
        checkListTip: 'Please check before booking',
        operator: 'Operator',
        paymentDate: 'Scheduled Remittance Date',
        message: 'message',
        requiredInfo: 'Required Information',
        requiredInfoPerParticipant: 'Required Information (Per Participant)',
        allotmentQuantity: 'Quantity {{quantity}}',
        paymentCurrency: 'Payment Amount (Sales Price)',
        totalPriceForBooking: 'Total Local Currency Amount',
        paymentCurrencyExchange: 'Exchange Rate',
        unit: 'unit',
        representative: 'Participant Representative',
        pleaseSelectUnit: 'Please select a unit.',
        displayPrice: 'Selling price',
        netPrice: 'Wholesale Price'
      },
      bookingConfirmation: {
        title: 'Booking Accepted',
        message: 'Application has been completed and sent to the operator',
        reservationNumber: 'Booking Number',
        print: 'Printable',
        display: 'Display'
      },
      participantInfo: {
        firstName: 'Representative (First Name)',
        lastName: 'Representative (Last Name)',
        agentReservationNo: 'Travel agency reservation number (remarks)',
        agentReservationNote: 'Special notes for travel agency bookings'
      },

      bookingFields: {
        participantEmailAddress: 'Participant Email Address',
        hotelName: 'Hotel Name',
        hotelAddress: 'Hotel Address',
        hotelReservationLastName: 'Hotel Representative Last Name',
        hotelReservationFirstName: 'Hotel Representative First Name',
        hotelReservationName: 'Hotel Representative Name',
        hotelTel: 'Hotel Phone Number',
        arrivalDate: 'Local Arrival Date',
        arrivalTime: 'Arrival Time',
        arrivalFlightNumber: 'Flight Arrival Number',
        departureDate: 'Departure Date',
        departureTime: 'Departure Time',
        departureFlightNumber: 'Flight Departure Number',
        destinationEmail: 'Local Contact (Email Address)',
        destinationTel: 'Local Contact (Phone Number)',
        gender: 'Gender',
        agentChannelRegion: 'Country/region where the travel agency is located',
        agentChannelLanguage: 'travel agency language',
        participantResidentRegion: 'Participant Country / Region of Residence',
        participantLanguage: 'Participant Language',
        passengersQuantity: 'Number of Passengers',
        prescriptionMaskQuantityFree: 'Prescription Mask Request *Free',
        prescriptionMaskQuantityPaid: 'Prescription Mask Request *Paid on-site',
        preferredStartTime: 'Preferred Start Time',
        preferredPickUpLocation: 'Pickup / Boarding Location',
        preferredDropOffLocation: 'Drop-off / Drop Location',
        participantsQuantity: 'Number of Participants',
        luggageQuantity: 'Total Suitcase Count',
        childrenWithoutSeatQuantity: 'Infant (No Seat Required)',
        childSeatQuantityPaid: 'Child Seat (Paid on-site)',
        childSeatQuantityFree: 'Child Seat (Free)',
        guideJa: 'Japanese-speaking Guide Requested',
        driverJa: 'Japanese-speaking Driver Requested',
        guideEn: 'English-speaking Guide Requested',
        driverEn: 'English-speaking Driver Requested',
        guideZh: 'Chinese-speaking Guide Requested',
        driverZh: 'Chinese-speaking Driver Requested',
        guideKo: 'Request for a Korean-speaking guide',
        driverKo: 'Korean-speaking driver wanted',
        preferredGuideLanguageCode: 'Preferred Guide Language',
        preferredDriverLanguageCode: 'Preferred Driver Language',
        passportNationality: 'nationality',
        passportFirstName: 'Participant Given Name (Passport Romanization)',
        passportLastName: 'Participant Surname (Passport Romanization)',
        dateOfBirth: 'Date of Birth',
        age: 'age',
        passportNumber: 'Passport Number',
        eyesight: 'Vision',
        weightKg: 'Weight (kg)',
        heightCm: 'Height (cm)',
        shoeSizeCm: 'Shoe size (cm)',
        weightLbs: 'Weight (lbs)',
        heightIn: 'Height (ft/in)',
        clothesSize: 'Clothing Size',
        vegetarianMeals: 'Vegetarian food preferred',
        divingExperienceTimes: 'Number of Diving Experiences',
        rentalEquipmentsFree: 'Equipment rental requested (free of charge)',
        rentalEquipmentsPayLocally:
          'Equipment rental requested. *Payment to be made on-site.',
        male: 'Male',
        female: 'Female',
        other: 'Other',
        yes: 'Yes',
        no: 'No'
      },

      alert: {
        warning:
          'Available inventory for the selected date is less than requested participants. Please change date or number of people',
        info: 'I agree to the cancellation policy and proceed',
        cannotBookAlone: 'The selected ticket cannot be purchased individually'
      }
    },
    reservations: {
      title: 'Unconfirmed Bookings'
    },
    agentDetail: {
      title: 'Travel agency information'
    },
    orgList: {
      title: 'Group Management'
    },
    agentAccountList: {
      title: 'Account Management'
    },
    bookReservations: {
      paymentAppliedDate: 'Payment Application Date',
      id: 'ID',
      productPlan: 'Product / Plan',
      expirationDate: 'Expiration Date',
      participationDate: 'Participation Date (Local Product)',
      holdReservation: 'Unconfirmed Reservation',
      count: 'Unit'
    }
  },
  const: {
    allotmentStatus: {
      plenty: 'In Stock',
      insufficient: 'Low Stock',
      empty: 'Out of Stock',
      unavailable: 'Not for sale'
    },
    bookingStatus: {
      yes: 'Available for Booking',
      no: 'Booking Not Allowed'
    },
    activityTags: {
      NON_CANCELLABLE: 'Cannot Cancel',
      FREE_CANCEL_BEFORE_ISSUE_TICKET: 'Free cancellation before exchange',
      ADVANCE_CANCELLATION_POLICY: 'Special Cancellation Policy',
      INSTANT_BOOK: 'Instant Booking',
      NON_QR_CODE: 'Physical Voucher',
      QR_CODE: 'QR Voucher',
      ETICKET: 'Ticket tear-off (smartphone required)'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: 'Unpaid',
      [InvoiceStatus.InvoiceStatusConfirmed]: 'Payment Completed',
      [InvoiceStatus.InvoiceStatusPaid]: 'Payment Confirmation in Progress',
      [InvoiceStatus.InvoiceStatusCancelled]: 'Cancelled'
    }
  }
};
